import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiDataType, EnvironmentInterface } from '../../types';
import { ClientUserService } from '../users/client/client.service';

@Injectable({
    providedIn: 'root'
})
export class FavoritesService {
    /* eslint-disable  */
    private environment: EnvironmentInterface;

    constructor(
        private http: HttpClient,
        private clientUserService: ClientUserService,
        @Inject('environment') environment: EnvironmentInterface
    ) {
        this.environment = environment;
    }

    favoritePro(id: number): Observable<ApiDataType> {
        return this.http.post<ApiDataType>(`${this.environment.apiUrl}/favorites/add/${id}`, '');
    }

    unfavoritePro(id: number): Observable<ApiDataType> {
        return this.http.post<ApiDataType>(`${this.environment.apiUrl}/favorites/remove/${id}`, '');
    }

    isFave(id: number) {
        this.unfavoritePro(id).subscribe(data => {
            // console.log(data);
            if (data.success === true) {
                this.clientUserService.getUpdatedUser();
            }
        });
    }

    isNotFave(id: number) {
        this.favoritePro(id).subscribe(() => {
            // console.log(data);
            this.clientUserService.getUpdatedUser();
        });
    }

    isItFave(id: number | string | undefined) {
        if (!id) return false;

        const userFaves = this.clientUserService.userFavorites();

        const isInFaves =
            userFaves && userFaves.some((elm: any) => parseInt(elm.id.toString()) === parseInt(id.toString()));

        return isInFaves;
    }

    clickFave(proId: number, currentStatus?: boolean | undefined) {
        let isFave = currentStatus || this.isItFave(proId);

        if (isFave === true) {
            this.isFave(proId);
            return false;
        } else {
            this.isNotFave(proId);
            return true;
        }
    }
}
